import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import UI from "../../../actions/ui-helper";
import API from "../../../actions/api-helper";

import ConsultaEmpresaResultado from "./ConsultaEmpresaResultado";

class ConsultaUsuario extends Component {
  constructor(props) {
    super(props);
    this.state = {
      consulta: {},
      resultado: []
    };

    this.handleEditar = this.handleEditar.bind(this);
  }

  componentDidMount() {
    UI.loader("show", "Um momento...");
    API.get("/empresas")
      .then(
        function (json) {
          this.setState({ resultado: json.data });
          UI.loader("hide");
        }.bind(this)
      )
      .catch(function (json) {
        UI.alert(false, json.message);
        UI.loader("hide");
      });
  }

  handleEditar(empresa, i) {
    this.props.history.push("/empresa/cadastro/" + empresa.id);
  }

  render() {
    return (
      <form
        className="form-sample"
        autoComplete="off"
        spellCheck="false"
        onSubmit={this.handleSubmit}
      >
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <h4 className="card-title">CONSULTA EMPRESA</h4>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      onClick={() => { this.props.history.push("/empresa/cadastro"); }}
                      className="btn btn-rounded btn-icons btn-outline-success"
                      type="button">
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <p className="card-description" />
                <div className="row">
                  <div className="col-md-12">
                    <ConsultaEmpresaResultado onEditar={this.handleEditar} resultado={this.state.resultado} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default withRouter(ConsultaUsuario);
